/**
 * یک sort واحد برای API — جلوگیری از تداخل rating + history
 */
export function resolveCatalogSort({ rating = 'all', history = 'all' }) {
  if (history === 'newest') return { sortBy: 'createdAt', sortOrder: 'desc' };
  if (history === 'oldest') return { sortBy: 'createdAt', sortOrder: 'asc' };
  if (history === 'updated') return { sortBy: 'updatedAt', sortOrder: 'desc' };
  if (history === 'trending') return { sortBy: 'views', sortOrder: 'desc' };

  if (rating === 'high') return { sortBy: 'rating', sortOrder: 'desc' };
  if (rating === 'medium') return { sortBy: 'rating', sortOrder: 'desc' };
  if (rating === 'low') return { sortBy: 'rating', sortOrder: 'asc' };

  return { sortBy: 'createdAt', sortOrder: 'desc' };
}
